import {useState } from 'react';
import { Typography } from '@mui/material';
import '../Styles/CategoryStyles.css';
import ItemSubCategoryList from '../statefull/ManageItemSubCategory/ItemSubCategoryList';
import { useTranslation } from 'react-i18next';


const ManageItemSubCategory = () => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const [mode, setMode] = useState<'add' | 'edit'>('add');
  // const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);

  const handleAddCategory = () => {
    setExpanded((prev) => !prev);
    setMode('add');
  };

  const handleEditCategory = () => {
    // setSelectedCategory(category);
    setExpanded((prev) => !prev);
    setMode('edit');
  };

  return (
        <>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            {t('itemSubCategory.title')}
          </Typography>
          <ItemSubCategoryList
            editCategory={handleEditCategory}
            handleAddCategory={handleAddCategory}
            expanded={expanded}
            setExpanded={setExpanded}
            mode={mode}
            setMode={setMode}
          />
        </>
  );
};

export default ManageItemSubCategory;
